// extracted by mini-css-extract-plugin
export default {"baseTooltip":"tooltip_baseTooltip__qPEDP"};